import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../../auth/auth.service';
import {Store} from '@ngrx/store';

import * as fromApp from '../../../store/app.reducers';
import * as TrialActions from '../store/trial.actions';
import * as AuthActions from '../../../auth/store/auth.actions';

import {ActivatedRoute, Params} from '@angular/router';
import {Subscription} from 'rxjs';
import {Cookie} from '../../../helper/cookie';

@Component({
    selector: 'app-profile-trial-check',
    templateUrl: './profile-trial-check.component.html',
    styleUrls: ['./profile-trial-check.component.scss'],
    standalone: false
})
export class ProfileTrialCheckComponent implements OnInit, OnDestroy {

  routeSubscription: Subscription;
  profile: string;

  constructor(
    private authService: AuthService,
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.profile !== undefined) {
          this.profile = params.profile;
          const cookies = new Cookie();

          this.store.dispatch(
            new TrialActions.AddTrialUserWithAudit({
              profile: this.profile,
              userUid: cookies.getCookie('auditor-uid')
            })
          );

          if (cookies.getCookie('auditor-token') === undefined) {
            this.store.dispatch(
              new AuthActions.TrySinginByUid({
                userUid: cookies.getCookie('auditor-uid'),
                withRedirect: false
              })
            );
          }
        }
      }
    );
  }

  isAuthenticated() {
    return this.authService.isAuthenticated();
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

}
